// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterWrapper_wrapper__k5PNh"};